import { render, staticRenderFns } from "./projectPublicityDetail.vue?vue&type=template&id=5633ff0c&scoped=true"
import script from "./projectPublicityDetail.vue?vue&type=script&lang=js"
export * from "./projectPublicityDetail.vue?vue&type=script&lang=js"
import style0 from "./projectPublicityDetail.vue?vue&type=style&index=0&id=5633ff0c&prod&scoped=true&lang=css"
import style1 from "./projectPublicityDetail.vue?vue&type=style&index=1&id=5633ff0c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5633ff0c",
  null
  
)

export default component.exports